import { CallCost } from "@/redux/slices/callcosts/type";
import axios from "axios";

export const fetchCallCosts = async () => {
  return await axios.get<CallCost>("/svc/voice/calls");
};
